// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React, { Component } from 'react';
import Editor from 'react-ace';

// Syntax highlighting
import 'ace-builds/webpack-resolver';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-xcode';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-twilight';
import 'ace-builds/src-noconflict/ext-language_tools';

import '../styles/codeEditor.css'

const languages = {
    'py': 'python',
    'js': 'javascript'
};

export default class CodeEditor extends Component {


    state = {
        localValue: null,
    }


    onChange = (newValue) => {

        // Update parent if not internal-editing
        if (!this.props.editInternal) {
            this.props.onChange(newValue);
            return;
        }

        // Else : Update internally
        else {
            this.setState({
                localValue: newValue,
            });
            return;
        }

    }

    onConfirmClick = async () => {

        // Update
        await this.props.onChange(this.state.localValue);

        // Clear local 
        await this.setState({
            localValue: null
        });

    }


    render = () => {

        // Should use internal value? 
        const usingLocalValue = (this.props.editInternal && (this.state.localValue || this.state.localValue===''));

        // Get current value 
        const value = usingLocalValue ? this.state.localValue : this.props.value;


        return (
        
            <div style={{position: 'relative'}}>
        
                <Editor
                    className={this.props.className ? this.props.className : ""}
                    style={this.props.style ? this.props.style : {}}
                    name={this.props.name}
                    mode={languages[this.props.language ?? "py"]}
                    theme={this.props.theme ?? "xcode"}
                    height={this.props.height ?? '240px'}
                    width={this.props.width ?? '100%'}
                    onChange={this.onChange}
                    value={value}
                    fontSize={14}
                    showPrintMargin={true}
                    showGutter={true}
                    highlightActiveLine={true}
                    setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableSnippets: true,
                        showLineNumbers: true,
                        tabSize: 4
                    }}
                />

                {usingLocalValue && <img 
                    alt="Save"
                    src="https://static.stax.ai/images/icons/confirm.png"
                    title="Click to save"
                    className="code-edit-confirm-button"
                    onClick={this.onConfirmClick}
                />}

            </div>
        
        );

    }

};